import React, { memo, forwardRef } from "react";
const SvgIota = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M16.624 22.656c-.832 0-1.52-.152-2.064-.456a2.785 2.785 0 01-1.176-1.32c-.256-.576-.384-1.264-.384-2.064v-8.264a1 1 0 011-1h.112a1 1 0 011 1v8.336c0 .784.168 1.32.504 1.608.336.272.76.408 1.272.408.32 0 .6-.024.84-.072.378-.071.744.21.744.595v.352c0 .355-.219.677-.567.745a5.446 5.446 0 01-.201.036 5.305 5.305 0 01-1.08.096z"
      />
    </svg>
  );
});
SvgIota.displayName = "SvgIota";
const MemoForwardRef = memo(SvgIota);
export default MemoForwardRef;
